module.exports = __webpack_public_path__ + "img/glasstype-sport.265743c1.svg";